export const ANOMALY_LAYERS = [
  {
    displayName: "Precipitation",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M4.60059 17.1035C5.09745 17.1044 5.5 18.7159 5.5 19.1729C5.49974 19.6297 5.09651 20 4.59961 20C4.10289 19.9998 3.70045 19.6296 3.7002 19.1729C3.7002 18.7158 4.10353 17.1035 4.60059 17.1035ZM10 17.1035C10.4971 17.1035 10.9004 18.7158 10.9004 19.1729C10.9001 19.6297 10.4969 20 10 20C9.5031 20 9.09987 19.6297 9.09961 19.1729C9.09961 18.7158 9.50302 17.1039 10 17.1035ZM15.4004 17.1035C15.8973 17.1044 16.2998 18.7159 16.2998 19.1729C16.2995 19.6296 15.8971 19.9998 15.4004 20C14.9035 20 14.5003 19.6297 14.5 19.1729C14.5 18.7158 14.9033 17.1035 15.4004 17.1035ZM1.90039 14C2.39727 14.0007 2.7998 15.4054 2.7998 15.8623C2.79967 16.3191 2.39718 16.6893 1.90039 16.6895C1.40342 16.6895 1.00014 16.3193 1 15.8623C1 15.4052 1.40333 14 1.90039 14ZM7.2998 14C7.79686 14 8.2002 15.4052 8.2002 15.8623C8.20006 16.3193 7.79678 16.6895 7.2998 16.6895C6.80292 16.6894 6.40053 16.3192 6.40039 15.8623C6.40039 15.4053 6.80284 14.0004 7.2998 14ZM12.7002 14C13.1972 14.0004 13.5996 15.4053 13.5996 15.8623C13.5995 16.3192 13.1971 16.6894 12.7002 16.6895C12.2032 16.6895 11.7999 16.3193 11.7998 15.8623C11.7998 15.4052 12.2031 14 12.7002 14ZM18.1006 14C18.5975 14.0008 19 15.4054 19 15.8623C18.9999 16.3193 18.5966 16.6895 18.0996 16.6895C17.6028 16.6893 17.2003 16.3191 17.2002 15.8623C17.2002 15.4052 17.6035 14 18.1006 14ZM10 0C12.1407 0 13.7219 0.926217 14.7559 2.09766C15.5076 2.94939 15.9894 3.95329 16.1836 4.84961C16.57 4.91111 17.0713 5.02707 17.583 5.24609C18.1415 5.4852 18.7504 5.86363 19.2217 6.46875C19.7042 7.08831 20 7.89168 20 8.8877C20 9.85773 19.7446 10.6462 19.3164 11.2646C18.8942 11.8744 18.3418 12.2649 17.8252 12.5137C17.311 12.7612 16.8081 12.8807 16.4424 12.9395C16.2574 12.9691 16.1014 12.9834 15.9883 12.9912L15.7861 13H5.04102C4.02838 12.9999 2.79821 12.6422 1.80273 11.8633C0.778024 11.0615 0 9.80583 0 8.0918C1.21764e-05 6.37779 0.778032 5.12213 1.80273 4.32031C2.61599 3.68399 3.58584 3.32844 4.46582 3.21973C4.48062 3.19349 4.49657 3.16628 4.5127 3.13867C4.71643 2.78992 5.03121 2.32775 5.48145 1.86523C6.39348 0.928436 7.8551 0 10 0ZM10 1.85742C8.42615 1.85742 7.40808 2.51988 6.77051 3.1748C6.44613 3.50803 6.21915 3.84268 6.07422 4.09082C6.00232 4.21392 5.95175 4.31369 5.9209 4.37891C5.90561 4.41125 5.89436 4.43496 5.88867 4.44824L5.88477 4.45996L5.6582 5.04102H5.04102C4.40088 5.04109 3.5654 5.28067 2.9082 5.79492C2.28013 6.28646 1.81837 7.02025 1.81836 8.0918C1.81836 9.16334 2.28014 9.89713 2.9082 10.3887C3.5654 10.9029 4.40088 11.1425 5.04102 11.1426H15.7939C15.8081 11.1421 15.8328 11.141 15.8662 11.1387C15.9337 11.134 16.0357 11.1245 16.1602 11.1045C16.4141 11.0637 16.7387 10.9843 17.0508 10.834C17.3604 10.6849 17.6344 10.4777 17.832 10.1924C18.0237 9.91547 18.1816 9.5095 18.1816 8.8877C18.1816 8.29198 18.0136 7.90083 17.7988 7.625C17.5729 7.33487 17.251 7.11687 16.8799 6.95801C16.5095 6.79953 16.1263 6.71651 15.8271 6.67383C15.68 6.65283 15.5589 6.64268 15.4775 6.6377C15.437 6.63521 15.3884 6.63333 15.3701 6.63281H14.4629V5.7041C14.4629 5.17358 14.158 4.19369 13.4053 3.34082C12.683 2.52257 11.5782 1.85742 10 1.85742Z"
          fill="#1E88E5"
        />
      </svg>
    ),
    color: "#2E51A9",
    months: ["1", "2"],
    dekads: ["1", "3"],
    dataunit: "mm",
    active: false,
  },
  {
    displayName: "Soil Moisture",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
      >
        <path
          d="M8 0.663086C10.4812 2.81387 12.3392 4.8052 13.585 6.6416C14.8858 8.55927 15.4999 10.2746 15.5 11.7998C15.5 16.4884 11.9394 19.5 8 19.5C4.06059 19.5 0.5 16.4884 0.5 11.7998C0.500052 10.2746 1.11424 8.55927 2.41504 6.6416C3.66075 4.8052 5.51878 2.81387 8 0.663086ZM7.66309 2.29102C5.619 4.15846 4.08598 5.89049 3.06152 7.46777C2.04048 9.03987 1.50005 10.4956 1.5 11.7998C1.5 15.6994 4.36739 18.5 8 18.5C11.6326 18.5 14.5 15.6994 14.5 11.7998C14.4999 10.4906 13.9589 9.03515 12.9375 7.46387C11.913 5.88781 10.3807 4.15822 8.33691 2.29102L8 1.98242L7.66309 2.29102ZM3.83008 12.5C3.93463 12.5 4.02629 12.5608 4.06543 12.667L4.0791 12.7158C4.54693 15.2348 6.68537 16.1055 8.23242 15.9883L8.2334 15.9893C8.38178 15.9825 8.5 16.099 8.5 16.2402C8.49987 16.3681 8.39433 16.4833 8.25488 16.4902L8.25 16.4912C6.32268 16.6088 4.09704 15.515 3.58105 12.7812C3.55811 12.6468 3.67278 12.5 3.83008 12.5Z"
          fill="#8E24AA"
          stroke="#FB8C00"
        />
      </svg>
    ),
    color: "#ED6C02",
    months: ["1", "2"],
    dekads: ["1", "3"],
    dataunit: "%",
    active: false,
  },
  {
    displayName: "Vegetation",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="20"
        viewBox="0 0 23 20"
        fill="none"
      >
        <path
          d="M17.5682 4.89621C17.5682 4.89621 15.9583 8.27149 15.4322 11.6119C14.9258 14.8274 15.2494 19.9317 15.2494 19.9317H17.2594C17.2594 19.9317 16.3047 14.8724 16.4372 11.6119C16.5711 8.31859 17.5682 4.89621 17.5682 4.89621Z"
          fill="#43A047"
        />
        <path
          d="M3.92998 8.6124C3.92998 8.6124 6.76827 10.845 7.29435 13.9112C7.80075 16.8627 7.63317 19.9317 7.63317 19.9317H5.62324C5.62324 19.9317 6.42191 16.904 6.28938 13.9112C6.15552 10.8882 3.92998 8.6124 3.92998 8.6124Z"
          fill="#43A047"
        />
        <path
          d="M5.48182 16.6459C5.28507 16.8195 5.06741 16.8708 4.98618 16.888C4.78955 16.9296 4.58221 16.9243 4.44324 16.9163C4.14046 16.8988 3.77662 16.8385 3.52104 16.7648C3.2678 16.6918 3.06891 16.535 2.9735 16.4568C2.85191 16.357 2.73207 16.2406 2.62861 16.1359C2.36917 15.8735 2.26094 15.7426 2.08812 15.5747L0.507444 14.0398L2.71043 14.012C2.89827 14.0097 3.18945 14.006 3.4674 14.0175C3.60621 14.0233 3.75609 14.0334 3.8972 14.0518C4.02021 14.0678 4.21049 14.0985 4.38921 14.1747C4.57314 14.2531 4.74728 14.3816 4.86011 14.4702C4.99238 14.574 5.12986 14.6962 5.25268 14.818C5.36849 14.9328 5.50343 15.0785 5.60577 15.2298C5.65072 15.2962 5.73461 15.4283 5.7822 15.5986C5.80581 15.6831 5.84686 15.9016 5.78032 16.1415C5.77757 16.1534 5.77758 16.1663 5.77431 16.1782C5.71584 16.3919 5.59509 16.5459 5.48182 16.6459ZM3.77329 15.8906C4.1418 15.9968 4.9574 16.0923 4.89425 15.9061C5.02351 15.8049 4.29924 15.1264 4.03165 15.0124C3.79124 14.9104 3.10202 14.9176 2.72201 14.9224C3.0426 15.2339 3.52765 15.8198 3.77329 15.8906Z"
          fill="#43A047"
        />
        <path
          d="M5.0246 12.9265C4.81462 13.0839 4.59357 13.1177 4.51122 13.1283C4.3119 13.1541 4.10564 13.1323 3.96775 13.1132C3.66733 13.0716 3.30947 12.9825 3.06058 12.8886C2.81397 12.7956 2.62822 12.6235 2.53937 12.5379C2.42612 12.4288 2.31595 12.3031 2.22117 12.1905C1.9835 11.9082 1.88606 11.7692 1.72718 11.588L0.274026 9.93185L2.47221 10.0799C2.65963 10.0926 2.95018 10.1122 3.22632 10.1458C3.36423 10.1627 3.51282 10.1847 3.65202 10.2143C3.77335 10.2401 3.96058 10.2859 4.13265 10.376C4.30974 10.4689 4.47307 10.6109 4.57847 10.7082C4.70203 10.8222 4.82932 10.955 4.94204 11.0862C5.04831 11.2099 5.1712 11.3659 5.26115 11.5248C5.30065 11.5946 5.37374 11.733 5.40758 11.9065C5.42437 11.9927 5.44786 12.2137 5.36239 12.4476C5.3587 12.4592 5.35768 12.4721 5.35347 12.4837C5.27814 12.692 5.14548 12.8359 5.0246 12.9265ZM3.38177 12.0374C3.74063 12.1726 4.54602 12.3329 4.49793 12.1422C4.63484 12.0517 3.96702 11.3176 3.70939 11.1826C3.47789 11.0617 2.79028 11.0139 2.41111 10.9883C2.70583 11.3244 3.14257 11.9472 3.38177 12.0374Z"
          fill="#43A047"
        />
        <path
          d="M15.1996 7.15702C14.9441 7.21675 14.7281 7.15886 14.6484 7.13553C14.4556 7.07903 14.2754 6.97623 14.1568 6.90334C13.8984 6.74452 13.6066 6.5191 13.4163 6.33318C13.2279 6.14891 13.1269 5.91669 13.08 5.80259C13.0201 5.65715 12.9697 5.4978 12.9282 5.35663C12.824 5.00262 12.7906 4.83613 12.7179 4.60639L12.0527 2.50592L14.0061 3.52476C14.1726 3.61167 14.4308 3.74633 14.6702 3.88812C14.7897 3.95893 14.9169 4.03881 15.0325 4.12185C15.1332 4.19424 15.2863 4.31138 15.4076 4.46309C15.5325 4.61923 15.625 4.81491 15.6824 4.94636C15.7498 5.10047 15.813 5.27322 15.8635 5.43863C15.9111 5.59459 15.9609 5.78683 15.9794 5.96849C15.9876 6.04829 15.9989 6.20434 15.9602 6.37687C15.9409 6.46252 15.8736 6.67437 15.7014 6.85417C15.6934 6.86331 15.6872 6.87469 15.6787 6.88368C15.526 7.04416 15.3467 7.12264 15.1996 7.15702ZM14.0525 5.6827C14.3268 5.95076 14.9999 6.4211 15.0325 6.22722C15.1942 6.19933 14.8777 5.25871 14.696 5.03156C14.5326 4.82784 13.9221 4.50786 13.5852 4.33205C13.72 4.75822 13.8697 5.50401 14.0525 5.6827Z"
          fill="#43A047"
        />
        <path
          d="M17.9111 11.6416C18.1666 11.7013 18.3826 11.6434 18.4623 11.6201C18.6552 11.5636 18.8353 11.4608 18.9539 11.3879C19.2123 11.2291 19.5042 11.0037 19.6944 10.8177C19.8828 10.6335 19.9838 10.4012 20.0308 10.2871C20.0906 10.1417 20.141 9.98236 20.1826 9.84119C20.2868 9.48718 20.3201 9.32068 20.3928 9.09095L21.0581 6.99048L19.1046 8.00932C18.9381 8.09622 18.6799 8.23089 18.4406 8.37267C18.321 8.44348 18.1938 8.52337 18.0782 8.60641C17.9775 8.6788 17.8245 8.79594 17.7031 8.94765C17.5782 9.10379 17.4857 9.29947 17.4283 9.43092C17.361 9.58503 17.2978 9.75778 17.2473 9.92318C17.1997 10.0791 17.1498 10.2714 17.1313 10.4531C17.1232 10.5329 17.1118 10.6889 17.1506 10.8614C17.1698 10.9471 17.2371 11.1589 17.4094 11.3387C17.4174 11.3479 17.4235 11.3592 17.432 11.3682C17.5847 11.5287 17.764 11.6072 17.9111 11.6416ZM19.0582 10.1673C18.784 10.4353 18.1108 10.9057 18.0783 10.7118C17.9165 10.6839 18.2331 9.74327 18.4148 9.51612C18.5782 9.3124 19.1887 8.99242 19.5256 8.8166C19.3907 9.24277 19.241 9.98857 19.0582 10.1673Z"
          fill="#43A047"
        />
        <path
          d="M17.9285 4.6511C18.184 4.71083 18.4 4.65294 18.4797 4.62961C18.6726 4.57311 18.8527 4.47031 18.9713 4.39742C19.2297 4.2386 19.5216 4.01318 19.7118 3.82726C19.9002 3.64299 20.0012 3.41077 20.0482 3.29667C20.108 3.15123 20.1584 2.99188 20.2 2.85071C20.3042 2.4967 20.3375 2.33021 20.4102 2.10047L21.0755 0L19.122 1.01884C18.9555 1.10574 18.6973 1.24041 18.458 1.38219C18.3384 1.453 18.2112 1.53289 18.0956 1.61593C17.9949 1.68832 17.8418 1.80546 17.7205 1.95717C17.5956 2.11331 17.5031 2.30899 17.4457 2.44044C17.3784 2.59455 17.3152 2.7673 17.2647 2.93271C17.2171 3.08867 17.1672 3.28091 17.1487 3.46257C17.1406 3.54237 17.1292 3.69842 17.168 3.87095C17.1872 3.9566 17.2545 4.16845 17.4267 4.34825C17.4348 4.35739 17.4409 4.36877 17.4494 4.37776C17.6021 4.53824 17.7814 4.61672 17.9285 4.6511ZM19.0756 3.17678C18.8014 3.44484 18.1282 3.91518 18.0957 3.7213C17.9339 3.69341 18.2505 2.75279 18.4321 2.52564C18.5956 2.32192 19.2061 2.00194 19.543 1.82612C19.4081 2.25229 19.2584 2.99809 19.0756 3.17678Z"
          fill="#43A047"
        />
        <path
          d="M17.6185 16.3215C17.8429 16.4575 18.0662 16.4695 18.1492 16.472C18.3501 16.4781 18.5532 16.4363 18.6886 16.4038C18.9835 16.333 19.3309 16.2092 19.5694 16.0915C19.8057 15.9748 19.9737 15.7853 20.0538 15.6914C20.1558 15.5717 20.2531 15.4359 20.3364 15.3145C20.5453 15.0103 20.6287 14.8624 20.769 14.6665L22.0531 12.8761L19.88 13.2387C19.6947 13.2696 19.4074 13.3175 19.1359 13.3781C19.0003 13.4083 18.8546 13.4448 18.719 13.4879C18.6007 13.5254 18.4189 13.5893 18.2565 13.6959C18.0893 13.8056 17.9407 13.9629 17.8453 14.0701C17.7335 14.1957 17.6198 14.3403 17.5205 14.4819C17.4269 14.6154 17.3198 14.7827 17.2459 14.9497C17.2134 15.023 17.1542 15.1678 17.1375 15.3439C17.1292 15.4313 17.1275 15.6535 17.2355 15.8779C17.2403 15.8891 17.2425 15.9018 17.2479 15.913C17.3432 16.1129 17.4893 16.2431 17.6185 16.3215ZM19.1664 15.2757C18.8225 15.4455 18.0367 15.6838 18.0659 15.4894C17.9208 15.4127 18.5135 14.6167 18.7567 14.4571C18.9752 14.3141 19.6549 14.1993 20.0297 14.1367C19.7693 14.5 19.3956 15.1626 19.1664 15.2757Z"
          fill="#43A047"
        />
        <path
          d="M14.5396 11.3012C14.3058 11.4203 14.0822 11.4157 13.9992 11.4121C13.7984 11.4033 13.599 11.3465 13.4664 11.3041C13.1775 11.2116 12.8402 11.0624 12.6111 10.9273C12.3841 10.7934 12.2306 10.5921 12.1577 10.4925C12.0648 10.3656 11.9778 10.2229 11.9037 10.0957C11.718 9.77686 11.6458 9.62316 11.5203 9.41745L10.3725 7.53677L12.5127 8.05935C12.6952 8.10395 12.9781 8.17302 13.2444 8.25351C13.3774 8.29371 13.52 8.34088 13.6521 8.3939C13.7672 8.44013 13.9438 8.5173 14.0979 8.63562C14.2565 8.7574 14.393 8.92531 14.4802 9.03923C14.5824 9.1728 14.685 9.32544 14.7736 9.47399C14.8571 9.61405 14.9514 9.78882 15.0128 9.96079C15.0398 10.0363 15.0881 10.1852 15.0917 10.3619C15.0935 10.4497 15.0787 10.6715 14.9545 10.8873C14.9488 10.898 14.9456 10.9106 14.9395 10.9213C14.8296 11.1136 14.6742 11.2327 14.5396 11.3012ZM13.0734 10.1437C13.4038 10.3385 14.1698 10.6343 14.1551 10.4383C14.3055 10.3726 13.7734 9.53482 13.5427 9.35767C13.3353 9.19889 12.6661 9.03405 12.2969 8.94383C12.5297 9.32544 12.8532 10.0139 13.0734 10.1437Z"
          fill="#43A047"
        />
        <path
          d="M14.1431 16.2663C13.9092 16.3853 13.6857 16.3807 13.6027 16.3771C13.4019 16.3683 13.2024 16.3116 13.0699 16.2691C12.781 16.1766 12.4437 16.0275 12.2146 15.8924C11.9876 15.7585 11.8341 15.5571 11.7612 15.4575C11.6683 15.3306 11.5813 15.1879 11.5072 15.0608C11.3215 14.7419 11.2493 14.5882 11.1238 14.3825L9.97594 12.5018L12.1162 13.0244C12.2987 13.069 12.5816 13.1381 12.8479 13.2186C12.9809 13.2588 13.1235 13.3059 13.2556 13.359C13.3707 13.4052 13.5473 13.4824 13.7014 13.6007C13.8599 13.7225 13.9965 13.8904 14.0837 14.0043C14.1859 14.1379 14.2885 14.2905 14.3771 14.439C14.4606 14.5791 14.5549 14.7539 14.6163 14.9259C14.6433 15.0014 14.6916 15.1502 14.6952 15.327C14.697 15.4148 14.6822 15.6366 14.5579 15.8523C14.5523 15.8631 14.5491 15.8756 14.543 15.8864C14.433 16.0787 14.2777 16.1978 14.1431 16.2663ZM12.6769 15.1088C13.0073 15.3035 13.7733 15.5994 13.7586 15.4033C13.909 15.3376 13.3769 14.4999 13.1462 14.3227C12.9388 14.164 12.2695 13.9991 11.9004 13.9089C12.1331 14.2905 12.4567 14.9789 12.6769 15.1088Z"
          fill="#43A047"
        />
        <path
          d="M7.90948 11.8133C8.17073 11.7888 8.35716 11.6653 8.42531 11.6179C8.59026 11.5031 8.72842 11.3484 8.81772 11.2416C9.01229 11.009 9.21747 10.7025 9.3388 10.4658C9.45897 10.2312 9.48094 9.97897 9.48924 9.85585C9.49981 9.69894 9.49698 9.53184 9.49155 9.38478C9.47794 9.016 9.45669 8.84753 9.45266 8.60661L9.41638 6.4036L7.88765 7.99008C7.75734 8.12538 7.55527 8.33507 7.37335 8.54553C7.2825 8.65063 7.18724 8.76679 7.10402 8.88223C7.0315 8.98287 6.92356 9.14255 6.85668 9.32494C6.78786 9.51266 6.76229 9.72758 6.74959 9.87047C6.7347 10.038 6.72964 10.2219 6.73427 10.3947C6.73864 10.5578 6.75243 10.7559 6.79257 10.934C6.81021 11.0123 6.84901 11.1638 6.94054 11.3151C6.98599 11.3902 7.1171 11.5697 7.33751 11.6855C7.34804 11.6916 7.35744 11.7005 7.3684 11.7063C7.56414 11.81 7.75909 11.8275 7.90948 11.8133ZM8.52898 10.051C8.35404 10.3923 7.86513 11.0521 7.77269 10.8786C7.61046 10.9035 7.61189 9.91106 7.71202 9.63797C7.80228 9.3929 8.27954 8.8956 8.54319 8.62189C8.55067 9.06882 8.64558 9.82355 8.52898 10.051Z"
          fill="#43A047"
        />
        <path
          d="M9.79049 13.6303C9.58179 13.7037 9.39709 13.7814 9.30611 13.8559C9.08156 14.0404 8.5777 14.8935 8.72896 14.9555C8.7207 15.1519 9.47641 14.8309 9.80025 14.6254C9.89711 14.5639 10.0103 14.3891 10.1264 14.1801L10.6538 15.0443C10.5726 15.151 10.4515 15.2905 10.2885 15.394C10.064 15.5365 9.7314 15.6963 9.44576 15.7983C9.31473 15.845 9.1176 15.9088 8.91744 15.9242C8.83465 15.9306 8.61112 15.9418 8.37349 15.8305C8.23672 15.7664 8.07754 15.6528 7.96138 15.4643C7.9549 15.4537 7.95075 15.4417 7.94478 15.4311C7.81359 15.2197 7.79163 14.9985 7.79049 14.9106C7.78828 14.7341 7.83143 14.5838 7.85592 14.5072C7.91161 14.3333 8.00069 14.1549 8.07955 14.0121C8.16315 13.8608 8.26019 13.7045 8.35787 13.5678C8.44124 13.4511 8.57257 13.2787 8.72701 13.1518C8.877 13.0286 9.05102 12.9459 9.16451 12.8959C9.21085 12.8755 9.25893 12.8562 9.30709 12.8373L9.79049 13.6303Z"
          fill="#43A047"
        />
        <path
          d="M12.2065 12.3461L11.3178 12.1293L12.6284 11.6264L12.2065 12.3461Z"
          fill="#43A047"
        />
        <path
          d="M3.4013 8.60941C3.14952 8.68328 2.93063 8.63753 2.84977 8.61867C2.65405 8.57301 2.46846 8.48042 2.34599 8.41425C2.07915 8.27008 1.77516 8.06127 1.57487 7.88625C1.37645 7.71276 1.26271 7.48653 1.20946 7.37522C1.14159 7.23335 1.0824 7.07706 1.03304 6.93842C0.909256 6.59077 0.866675 6.42639 0.781286 6.20107L0 4.14094L2.00718 5.04932C2.1783 5.12681 2.44361 5.24687 2.69048 5.37509C2.81377 5.43913 2.94524 5.5118 3.06527 5.58827C3.16987 5.65494 3.32923 5.76336 3.45884 5.90807C3.59222 6.05701 3.69549 6.24723 3.76015 6.37527C3.83594 6.52539 3.90868 6.69435 3.96833 6.85668C4.02457 7.00975 4.08505 7.19891 4.11366 7.37926C4.12622 7.45849 4.14625 7.61366 4.11718 7.78808C4.10274 7.87467 4.04734 8.08995 3.88541 8.27906C3.87789 8.28863 3.87243 8.30033 3.86439 8.30979C3.7209 8.47853 3.54625 8.56688 3.4013 8.60941ZM2.1738 7.20131C2.46258 7.45367 3.16088 7.88577 3.18258 7.69037C3.34253 7.6535 2.97404 6.73199 2.77998 6.51532C2.60546 6.32103 1.97809 6.03557 1.63189 5.87881C1.79028 6.2968 1.98131 7.0331 2.1738 7.20131Z"
          fill="#43A047"
        />
      </svg>
    ),
    color: "#21AF48",
    months: ["1", "2"],
    dekads: ["1", "3"],
    dataunit: "unit",
    active: false,
  },
  {
    displayName: "Hybrid Index",
    chip: "Expert",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
      >
        <path
          d="M7 0.5C7.54174 0.5 8.06567 0.575305 8.56738 0.708008C6.20433 3.10739 6 6.05413 6 7C6 7.94581 6.20479 10.8917 8.56738 13.291C8.0656 13.4238 7.54183 13.5 7 13.5C3.41614 13.5 0.5 10.5839 0.5 7C0.5 3.41614 3.41614 0.5 7 0.5ZM15 0.5C18.5839 0.5 21.5 3.41614 21.5 7C21.5 10.5839 18.5839 13.5 15 13.5C14.4574 13.5 13.9331 13.4231 13.4307 13.29C13.7071 13.0075 13.9536 12.7164 14.1738 12.4238C14.4386 12.4707 14.7152 12.5 15 12.5C18.0361 12.5 20.5 10.0361 20.5 7C20.5 3.96386 18.0361 1.5 15 1.5C14.7153 1.5 14.4386 1.52839 14.1738 1.5752C13.9536 1.28267 13.7071 0.991518 13.4307 0.708984C13.933 0.575939 14.4575 0.5 15 0.5ZM11 1.75977C11.5486 1.75977 12.1667 2.19521 12.6777 3.17285C13.1762 4.12664 13.5 5.47889 13.5 7C13.5 8.52111 13.1762 9.87336 12.6777 10.8271C12.1667 11.8048 11.5486 12.2402 11 12.2402C10.4514 12.2402 9.83327 11.8048 9.32227 10.8271C8.82377 9.87336 8.5 8.52111 8.5 7C8.5 5.47889 8.82377 4.12664 9.32227 3.17285C9.83327 2.19521 10.4514 1.75977 11 1.75977Z"
          fill="#8E24AA"
          stroke="#8E24AA"
        />
      </svg>
    ),
    color: "#8E24AA",
    months: ["1", "2"],
    dekads: ["1", "3"],
    parameters: [
      { name: "Soil Moisture", value: 50 },
      { name: "Precipitation", value: 50 },
    ],
  },
];

export const CLIMATE_LAYERS = [
  {
    // id: "precipitation",
    // timeseriesGroupId: "9a5b70fb-38f8-43d4-88b3-b5d3ecd1cbe1",
    displayName: "Precipitation",
    time: {
      default: "2023-01-01T00:00:00+00:00",
      end: "2023-11-18T00:00:00+00:00",
      start: "2000-06-03T00:00:00+00:00",
      td: 86400,
    },
    isDisabled: false,
    dataunit: "mm",
    isVisible: false,
  },
  {
    // id: "soil-moisture",
    // timeseriesGroupId: "1313a856-2f8b-4f80-b005-8d463b84447b",
    displayName: "Soil Moisture",
    time: {
      default: "2023-01-01T00:00:00+00:00",
      end: "2023-11-18T00:00:00+00:00",
      start: "2000-06-03T00:00:00+00:00",
      td: 86400,
    },
    isDisabled: false,
    dataunit: "%",
    isVisible: false,
  },
  {
    // id: "vegetation",
    // timeseriesGroupId: "3ef1227e-22a2-47a2-8106-0d63d07b142c",
    displayName: "Vegetation",
    time: {
      default: "2023-01-01T00:00:00+00:00",
      end: "2023-11-18T00:00:00+00:00",
      start: "2000-06-03T00:00:00+00:00",
      td: 86400,
    },
    dataunit: "unit",
    isDisabled: false,
    isVisible: false,
  },
] as const;

type LegendEntry = {
  label: string;
  color: string;
  limit: [number, number] | null;
};

export const MAP_LEGEND: Record<string, LegendEntry> = {
  extremeStress: {
    label: "< -2 (Extreme)",
    color: "#B35707",
    limit: [-Infinity, -2],
  },
  severeStress: {
    label: "-2 to -1.5 (Severe)",
    color: "#F1A440",
    limit: [-2, -1.5],
  },
  moderateStress: {
    label: "-1.5 to -1 (Moderate)",
    color: "#FEE0B6",
    limit: [-1.5, -1],
  },
  nearNormal: {
    label: "-1 to 1 (Near Normal)",
    color: "#FFFFFF",
    limit: [-1, 1],
  },
  moderateGreenness: {
    label: "1 to 1.5 (Moderate)",
    color: "#D2E4F0",
    limit: [1, 1.5],
  },
  highGreenness: {
    label: "1.5 to 2 (High)",
    color: "#67A8CE",
    limit: [1.5, 2],
  },
  extremeGreenness: {
    label: ">= 2 (Extreme)",
    color: "#2066AC",
    limit: [2, Infinity],
  },
  "N/A": {
    label: "N/A",
    color: "#C1C1C1",
    limit: null,
  },
};

export const getColorForValue = (value?: number): string => {
  if (!value) return "";

  for (const key in MAP_LEGEND) {
    const entry = MAP_LEGEND[key];

    if (!entry.limit) continue;

    const [min, max] = entry.limit;

    if (value >= min && value < max) {
      return entry.color;
    }
  }

  return "";
};

export const hexToRGB = (hex: string): [number, number, number, number] => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  return [
    (bigint >> 16) & 255,
    (bigint >> 8) & 255,
    bigint & 255,
    255, // opacity
  ];
};
